<template>
    <div class="select-product">
        <el-dialog title="添加" :visible.sync="dialogVisible" width="992px">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-select v-model="formInline.type" placeholder="请选择类型">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="活动名称" value="1"></el-option>
                            <el-option label="快递单号" value="2"></el-option>
                            <el-option label="联系人" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.data" placeholder="请输入安装产品" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table">
                <el-table v-loading="tabload" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column label="编号ID"> </el-table-column>
                    <el-table-column prop="name" label="安装类型"> </el-table-column>
                    <el-table-column prop="address" label="安装产品" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="aa" label="区域" show-overflow-tooltip> </el-table-column>
                </el-table>
                <div class="pageList">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                    >
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false" size="medium">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            formInline: {},
            tableData: [],
            multipleSelection: [],
        };
    },
    methods: {
        getList(tag) {
            this.tabload = true;
            if (this.formInline.type != 0 && !this.formInline.data) {
                this.$message.warning("请填写活动名称！");
            }
            let opt = {
                token: this.getToken,
                type: this.formInline.type == 0 ? null : this.formInline.type, //0-忽略此条件 1-活动名称 2-快递单号 3-联系人
                data: this.formInline.data, //输入的数据
                status: this.activeName == 0 ? null : this.activeName, //状态 1-未邮寄 2-已邮寄
                page_size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
            };
            this.posterList(opt).then((res) => {
                this.tabload = false;
                if (res.code == 1) {
                    this.tableData = res.data.data;
                    this.total = res.data.total ? res.data.total : 0;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        bindData() {
            this.dialogVisible = true;
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                type: "0",
                data: "",
            };
            this.getList(1);
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.select-product {
    ::v-deep .has-gutter tr th {
        background-color: rgb(217, 236, 255) !important;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
}
</style>